import { HttpHeaders, HttpParams } from '@angular/common/http';


export interface IPageableParams {
  page?: number;
  size?: number;

  /* 
  Exemplo para ordenar por mais de 1 campo:
  sort: ['prioridade,desc', 'dataSolicitacao,asc'] 
  */
  sort?: any;
}

export interface DefaultFilter extends IPageableParams {
  id?: number;
  status?: string;
}

export class DefaultServiceInterface {
    public httpOptions = {
        headers: new HttpHeaders({
            'Content-Type':  'application/json',
        })
    };

    public static converterFiltroParaHttpParam(filter: any, params?: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }
        
        if (filter) {
            Object.keys(filter).forEach(key => {
              const o = filter[key];

              // tratar sort
              if ( key === 'sort' && Array.isArray(o) ) {
                o.forEach(item => {
                  params = params.append(key, item);
                })
              }
              else {
                params = params.append(key, o);
              }
            });
        }
        return params;
    }
}
